module.exports = __webpack_public_path__ + "static/media/espa.17958499.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/espa.jpg
// module id = 1279
// module chunks = 0